<template>
  <div class="nav-top-bar">
        <div class="is-nav-bar">
            <div class="is-double-ended is-padded-10">
                <div class="is-left-end">
                    <p class=" is-left-item is-logo">bezie</p>
                </div>
                <div class="is-right-end">
                    
                    <div class="left right is-nav-button">
                        <!--<a href="https://www.surveymonkey.com/r/XH85SMP" target="_blank" style="color:white">-->
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScg7UWiN3rEFMc7OSwghoMK6kf-OYOur6kfDMU4Zvd9FELXOA/viewform?usp=sf_link"
                            target="_blank" style="color:white">
                        <i class="icon icon-heart" style="margin-right:5px"></i>
                        Feedback
                        </a>
                    </div>
                    
                    <div class="left right is-nav-button" 
                        @click="showSettings=true"><i class="icon icon-settings" style="margin-right:5px;margin-left:5px"></i>Settings</div>
                    <!--<at-button type="text" class="is-right-item" icon="icon-settings" @click="showSettings=true">Settings</at-button>-->
                    <div class="left right is-nav-button downloadClickableBtn"
                        @click="save"><i class="icon icon-download" style="margin-right:5px;margin-left:5px"></i>Download</div>
                    
                    <!--<at-button class="is-right-item" icon="icon-download">Download</at-button>-->
                </div>
            </div>
        </div>

        <Settings 
            v-bind:show_settings="showSettings" v-bind:bezieAppObj="bezieAppObj"
            v-on:close="closeSettingsModal" />

        <SaveAs 
            v-bind:show_saveas="showSaveAs" v-bind:bezieAppObj="bezieAppObj"
            v-on:close="closeSaveAsModal" />
  </div>
</template>

<script>
import Settings from './navBar/Settings.vue';
import SaveAs from './navBar/SaveAs.vue';
import { BezieApp } from '../lib/bezieLib/BezieApp';
import { UIEvents } from '../lib/bezieLib/UI/UIEvents';
import GifJS from '../lib/external/gif/gif';
import { UIUpdate } from '../lib/bezieLib/UI/UIUpdate';

export default {
    name: 'NavTopBar',
    components: {
        Settings, SaveAs
    },
    props: {
        bezieAppObj: BezieApp
    },
    data: function(){
        return {
            showSettings: false,
            showSaveAs: false
        }
    },
    methods: {
        closeSettingsModal(val){
            this.showSettings = false;
        },
        save(){
            if(this.bezieAppObj){
                this.showSaveAs = true;
            }else{
                this.$Notify({
                    title: 'Initialization error',
                    message: 'Kindly close and reload the page.',
                    type: 'error'
                })
            }
        },
        closeSaveAsModal(val){
            this.showSaveAs = false;
        }
    }
}
</script>

<style>
.downloadClickableBtn{
    background: #fa8528;
    border-radius: 2px;
    padding: 5px 14px 5px 10px;
}

.is-nav-bar{
    height:50px;
    background:linear-gradient(to right,#f7b733, #fa6321);
}

.is-nav-button{
    color:white; 
    cursor:pointer;
    vertical-align: center;
}

.is-logo {
  font-size: 32px;
  font-family: 'Pacifico', cursive;
  color: white;
}

.is-padded-10{
    padding: 10px;
}

.is-double-ended{
    display: flex;
    justify-content: space-between;
    height: 100%;
}

.is-right-end {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
}

.is-right-item{
    margin-right: 5px;
}

.is-left-item{
    margin-left: 5px;
}

.is-left-end{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
}

</style>
